
import React from "react";

interface WebsiteLogoProps {
  width?: number;
  height?: number;
  className?: string;
  alt?: string;
}

const WebsiteLogo: React.FC<WebsiteLogoProps> = ({
  width = 180,
  height,
  className = "",
  alt = "KidsBooked Logo"
}) => {
  // Calculate height based on aspect ratio if only width is provided
  const logoUrl = "https://firebasestorage.googleapis.com/v0/b/kb-prod-fb-proj.appspot.com/o/app%2Flogo%2Fkblogo24_740.png?alt=media&token=c988effc-4e43-443e-82e9-ff30a83c5317";

  return (
    <img
      src={logoUrl}
      alt={alt}
      width={width}
      height={height}
      className={`object-contain ${className}`}
      style={{ 
        width: width ? `${width}px` : undefined,
        height: height ? `${height}px` : undefined,
        maxWidth: "100%" 
      }}
    />
  );
};

export default WebsiteLogo;
